<div class="flex flex-col gap-1">
  <label class="text-sm font-medium text-slate-700 flex items-center gap-2">
    <i class="bi bi-geo-alt text-blue-600"></i>
    Sucursal
    @if (!canSelect()) {
      <i class="bi bi-lock-fill text-amber-500 text-xs" appTooltip="Sucursal asignada por el administrador" tooltipPosition="top"></i>
    }
  </label>

  @if (cargando()) {
    <div class="text-sm text-gray-500 italic">Cargando...</div>
  } @else if (opciones().length > 0) {
    <app-select
      [options]="opciones()"
      [ngModel]="sucursalActivaId()"
      (onChange)="onSucursalChange($event)"
      optionLabel="label"
      optionValue="value"
      placeholder="Selecciona"
      class="w-full sm:min-w-60 text-sm"
      appendTo="body"
      [disabled]="!canSelect()"
    />
  } @else {
    <div class="text-sm text-gray-500 italic">No disponible</div>
  }
</div>
